<template>
  <div id="app">
    <div class="app-message">
      Your account is still provisioning.<br>This might take a while...
      <br><br>If the app doesn't show up soon, please perform a browser refresh.
    </div>
  </div>
</template>

<script>
import {ENUMS} from "../../services/enums";
import router from "../../router";

export default {
  name: "ProvisioningNoticePage",
  metaInfo: {
    title: "Account Provisioning"
  },
  watch: {
    isAccountActive(newValue) {
      if (newValue) this.redirectToDashboard()
    }
  },
  computed: {
    account() {
      return this.$store.getters.account
    },
    isAccountActive() {
      return this.account.status === ENUMS.AccountStatusEnum.Active.value
    }
  },
  methods: {
    redirectToDashboard() {
      router.push({name: "user-dashboard", query: {modal: 'welcome'}})
    }
  }
}
</script>

<style scoped lang="scss">
.app-message {
  max-width: 700px;
  margin: 3rem auto 0;
  padding: 4rem 20px;
  text-align: center;
  font-size: 1.8rem;
  line-height: 1.5;
  color: #999;
}
</style>
